import { Card } from "./ui/card";

/**
 * Shared evidence visibility matrix.
 *
 * Renders a 6-column data-boundary table. Used by KatlasCapability and by every
 * satellite scenario so the data-visibility story is told identically across
 * the app.
 *
 * Pass `rows` as an array of 6-cell arrays. If omitted, renders the default
 * ClubCierge motorsport matrix that ships with the main demo.
 */
const DEFAULT_ROWS = [
  ["Driver profile ref",   "Marcus wallet / club role", "Yes",         "Yes",                  "Ref only",                "Yes"],
  ["Lap-time summary",     "Marcus wallet",             "If approved", "Yes",                  "Hash / ref only",         "If selected"],
  ["Coach endorsement",    "Club / coach role",         "If approved", "Yes",                  "Hash / ref only",         "If selected"],
  ["Full date of birth",   "Parent / member wallet",    "No",          "Restricted only",      "No",                      "No"],
  ["Family details",       "Parent wallet",             "No",          "No",                   "No",                      "No"],
  ["Safeguarding notes",   "Safeguarding role",         "No",          "Restricted only",      "No",                      "No"],
  ["Withheld media",       "Marcus wallet",             "No",          "Count / ref only",     "Count / ref only, no body","Count only"],
];

const DEFAULT_HEADERS = [
  "Evidence / fact",
  "Controlled by",
  "Visible to sponsor",
  "Visible to Club Secretary",
  "Sent to KATLAS node",
  "Public share",
];

export function EvidenceMatrix({ rows = DEFAULT_ROWS, headers = DEFAULT_HEADERS, title = "Evidence visibility matrix", subtitle, testId = "evidence-visibility-matrix" }) {
  return (
    <section className="space-y-3" data-testid={testId}>
      <div>
        <div className="tracking-eyebrow text-muted-foreground">Data boundary</div>
        <h2 className="text-2xl font-semibold mt-1">{title}</h2>
        {subtitle && (
          <p className="text-sm text-muted-foreground mt-1 max-w-3xl leading-relaxed">{subtitle}</p>
        )}
      </div>
      <Card className="border-border race-card overflow-x-auto">
        <table className="w-full text-[12px]" data-testid="evidence-matrix-table">
          <thead className="bg-[#FAFAFB]">
            <tr className="text-left">
              {headers.map((h, i) => (
                <th key={i} className="px-3 py-2 tracking-eyebrow text-muted-foreground font-normal">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {rows.map((row, i) => (
              <tr key={i} className="hover:bg-[#FAFAFB]">
                {row.map((cell, j) => (
                  <td key={j} className={`px-3 py-2 align-top ${j === 0 ? "font-medium" : "text-muted-foreground"}`}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
      <div className="text-[12px] italic text-muted-foreground">
        KATLAS records the governed action, not a copy of everyone's private data.
      </div>
    </section>
  );
}
